import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AACTContent from "./AACTContent";
import withErrorGuard from "../../../../../HOC/withErrorGuard";
import { displayVarsomePremiumLogo } from "../../../../../common/helpers/helpers";
import ComponentPanel from "../../../../../components/atoms/ComponentPanel/ComponentPanel";
import { getIsUserPremium } from "../../../../../state/selectors/general.selectors";
import HelperText from "../../../../../components/atoms/HelperText";

const AACT = ({ data, isUserPremium }) => {
  if (isUserPremium || __IS_COMPONENTS_PORTAL__) {
    if (data && Object.keys(data || {}).length > 0) {
      let content;
      if (data?.items && data?.items?.length) {
        content = <AACTContent aactList={data.items} />;
      }
      return (
        <div className="varsome-result-fixed" id="aact_component_varsome">
          <div className="varsome-container varsome-container__basic">
            <ComponentPanel
              title="AACT Clinical Trials"
              version={data?.version}
              url="https://www.ctti-clinicaltrials.org"
              helperPopup={
                <HelperText fieldDescriptionKey="AACT Clinical Trials" />
              }
              premiumLogo={displayVarsomePremiumLogo(false)}
              content={content}
            />
          </div>
        </div>
      );
    }
    return null;
  }
  return null;
};

AACT.propTypes = {
  data: PropTypes.shape({
    version: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  isUserPremium: PropTypes.bool,
};

AACT.defaultProps = {
  data: null,
  isUserPremium: false,
};

const mapStateToProps = (state) => {
  return {
    isUserPremium: getIsUserPremium(state),
  };
};

export default connect(
  mapStateToProps,
  {}
)(withErrorGuard(AACT, "AACT", "AACT Clinical Trials"));
